import { FunctionComponent } from 'react';
import useIsVT911CoreEnabled from '../../../../../hooks/useIsVT911CoreEnabled';
import { LiveVideoButtonContainer as CommunicatorLiveVideoButtonContainer } from './LiveVideoButtonContainer';
import LiveVideoButtonContainerLegacy from './LiveVideoButtonContainerLegacy';

interface Props {
  isForOverview?: boolean;
  onStartConversation: (message: string) => Promise<{ isSuccess: boolean }>;
}

export const LiveVideoButtonContainer: FunctionComponent<Props> = ({
  isForOverview = false,
  onStartConversation,
}) => {
  const isVT911CoreEnabled = useIsVT911CoreEnabled();

  if (isVT911CoreEnabled) {
    // If new livekit version of video to 911 is enabled use it
    return (
      <CommunicatorLiveVideoButtonContainer
        onStartConversation={onStartConversation}
      />
    );
  }

  return (
    <LiveVideoButtonContainerLegacy
      isForOverview={isForOverview}
      onStartConversation={onStartConversation}
    />
  );
};
